import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withSizes from 'react-sizes'
import {mapSizesToProps} from "../../utils";

import {t} from "../../Translations";
import Nav from './Nav';
import Configuration from "../../Configuration";

/**
 * @const Array<String> Step label tokens for mobile
 */
const stepLabels = [
    'Step2_bar_need_id_mobile',
    'Step2_bar_trips_id_mobile',
    'Step2_bar_route_id_mobile',
    'Step2_bar_driving_id_mobile'
]

/**
 * Class representing a responsive nav bar.
 */
class NavResponsive extends React.Component
{
    static propTypes = {
        className: PropTypes.string,

        // The active nav item
        active: PropTypes.number,

        // Steps labels
        steps: PropTypes.arrayOf(PropTypes.string),

        // Whether the use a mobile or not
        isMobile: PropTypes.bool,

        // Whether the use a tablet or not
        isTablet: PropTypes.bool
    };

    static defaultProps = {
        active: 0,
        isMobile: false
    };

    render() {
        const {steps, className, isMobile, isTablet, active} = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? " ap":"");
        const classes = classNames({
          [className]: className !== undefined,
          "step-mobile": isMobile || isTablet
        },
        client);
        return (
            (isMobile || isTablet) ? (
                <div className={classes}>
                    <p className={"step-number cccu-step"+client}>{t(stepLabels[active])}</p>
                    <p className="step-name cccu-step">{steps[active]}</p>
                </div>
            ) : (
                <Nav active={active} className={classes}>
                    {steps.map((step, index) =>
                        <div key={index} className={"step cccu-step"+client}>
                            <span className={"step-number cccu-step"+client}> {index + 1} </span>
                            <span>{step}</span>
                        </div>
                    )}
                </Nav>
            )
        )
    }
}

export default withSizes(mapSizesToProps)(NavResponsive);


// WEBPACK FOOTER //
// ./src/components/widgets/NavResponsive.js